import { render } from "../views/loader.html?vue&type=template&id=84573016&ts=true&external"
import script from "../scripts/loader.ts?vue&type=script&lang=ts&external"
export * from "../scripts/loader.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/loader.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84573016"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84573016', __exports__)) {
    api.reload('84573016', __exports__)
  }
  
  module.hot.accept("../views/loader.html?vue&type=template&id=84573016&ts=true&external", () => {
    api.rerender('84573016', render)
  })

}


export default __exports__